export default __webpack_public_path__ + "static/downtown2-51e0188cf22657a3de30ac3274b1a1bb.webp";